import React, { useState, useEffect } from 'react'
import { Card, Container, Form, Row, Col, Button, Spinner } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import { addUser, resetAddUser, resetAddUserError } from '../features/addUserSlice'
import ToastNotification from '../reusable-components/ToastNotification' // ✅ Import your toast component

export default function AddUser() {

    const [validated, setValidated] = useState(false);
    const [domainError, setDomainError] = useState(""); 
    const [showToast, setShowToast] = useState(false); 
    const [toastMessage, setToastMessage] = useState(""); 

    const { loading, isSuccess, error, errorMessage, addUserMessage } = useSelector((state) => state.addUser)
    const dispatch = useDispatch()

    const [formData, setFormData] = useState({
        user_email: "",
        user_role: "",
    });

    function handleChange(event) {
        setFormData(prevFormData => ({
            ...prevFormData,
            [event.target.name]: event.target.value
        }));
    }

    function handleEmailBlur() {
        if (formData.user_email && !formData.user_email.toLowerCase().endsWith("@siemens-energy.com")) {
            setDomainError("Please enter a valid Siemens Energy email (must end with @siemens-energy.com).");
        } else {
            setDomainError("");
        }
    }

    const handleSubmit = (event) => {
        event.preventDefault();
        const form = event.currentTarget;

        if (form.checkValidity() === false || domainError) {
            setValidated(true);
            event.stopPropagation();
            return;
        }

        const data = {
            'user_email': formData.user_email,
            'user_role': formData.user_role
        };
        dispatch(addUser(data));
    }

    // ✅ Handle success and error messages for toast display
    useEffect(() => {
        if (isSuccess) {
            setToastMessage(addUserMessage);
            setShowToast(true);
            dispatch(resetAddUser()); 
        }
    }, [isSuccess, addUserMessage, dispatch]);

    useEffect(() => {
        if (error) {
            setToastMessage(errorMessage);
            setShowToast(true);
            dispatch(resetAddUserError());
        }
    }, [error, errorMessage, dispatch]);

    return (
        <>
        
                <div className="p-3">
                    <ToastNotification
                        show={showToast}
                        onClose={() => setShowToast(false)}
                        message={toastMessage}
                    />
                </div>
            
            <h4>Add User</h4>
            <hr />
            {loading && <Spinner animation="border" />}

            <Card className="card border-dark mb-3">
                <Container className="card-header">Add New User</Container>
                <Container className="card-body">
                    <Form noValidate validated={validated} onSubmit={handleSubmit}>
                        <Row className="mb-3">
                            <Form.Group as={Col} md="6" controlId="useremailvalidator">
                                <Form.Label>Email Id:</Form.Label>
                                <Form.Control
                                    required
                                    type="email"
                                    placeholder="Email ID"
                                    value={formData.user_email}
                                    onChange={handleChange}
                                    onBlur={handleEmailBlur}
                                    name="user_email"
                                    isInvalid={!!domainError}
                                />
                                {domainError && (
                                    <div style={{ color: 'red', fontSize: '0.9em' }}>
                                        {domainError}
                                    </div>
                                )}
                            </Form.Group>

                            <Form.Group as={Col} md="6" controlId="user.ControlInput1">
                                <Form.Label>Select User Role:</Form.Label>
                                <Form.Select
                                    aria-label="Default select example"
                                    name="user_role"
                                    value={formData.user_role}
                                    onChange={handleChange}
                                    required
                                >
                                    <option label="Select a Role ..."></option>
                                    <option value="User">User</option>
                                    <option value="Admin">Admin</option>
                                </Form.Select>
                                <Form.Control.Feedback type="invalid">
                                    Select a role which the user needs access to.
                                </Form.Control.Feedback>
                            </Form.Group>
                        </Row>

                        <Button type="submit" disabled={loading}>Add User</Button>
                    </Form>
                </Container>
            </Card>

        </>
    );
}
